import { useState } from "react";

const PermissionSectionDisabled = ({ title, permissions, onToggle }) => (
  <div className="bg-gray-50 px-2 py-2 rounded-md">
    <h3 className="font-medium mb-3">{title}</h3>
    <div className="space-y-2">
      {permissions.map((perm) => (
        <div
          key={perm.unique_id}
          className="flex items-center justify-between text-sm gap-2"
        >
          {/* Text section */}
          <span className="capitalize break-words flex-1">
            {perm.display_name.replace(/([A-Z])/g, " $1")}
          </span>

          {/* Toggle switch */}
          <label className="relative inline-flex items-center  flex-shrink-0">
            <input
              type="checkbox"
              className="sr-only peer"
              checked={perm.status}
              disabled={true}
            />
            <div className="w-9 h-5 bg-gray-300 peer-checked:bg-[#0019CF] rounded-full peer transition-all duration-300"></div>
            <div className="absolute left-0.5 top-0.5 w-4 h-4 bg-white rounded-full shadow peer-checked:translate-x-4 transform transition-all duration-300"></div>
          </label>
        </div>
      ))}
    </div>
  </div>
);

export default PermissionSectionDisabled;
